import React from "react";
import TextArea from "../../../components/form-components/TextArea";
import { primaryButtonCls, secondaryButtonCls } from "../../../components/ui-components/buttonStyles.js";
import { ControlCheckFindingsList } from "../controlCheckFindings";
import { WizardCard } from "./WizardUI";

// Step 5+6 combined (spec §3.5/§3.6): the control-check runs
// (POST /roles/control-check) on entry to this step and renders findings
// grouped by severity. A critical finding blocks "Activate" until an
// override reason is supplied — "Save as draft" is always available since
// draft roles are never gated (the backend never runs the activation
// control-gate for a draft create, see roles_handlers.go CreateRole).
// Folded into one screen rather than two: the decision (draft vs activate)
// is inseparable from the findings that gate it, and the override-reason
// field naturally belongs right next to what it's overriding.
export default function StepControlCheck({
  isChecking,
  findings,
  checkError,
  overrideReason,
  setOverrideReason,
  onSaveDraft,
  onActivate,
  isSaving,
}) {
  const hasCritical = findings.some((f) => f.severity === "critical");
  const canActivate = !hasCritical || overrideReason.trim().length > 0;

  return (
    <WizardCard
      title="Control check"
      subtitle="Checks this role for segregation-of-duties conflicts, excessive access, and near-duplicate roles."
    >
      {isChecking && <div className="text-sm text-text-2">Running control check…</div>}

      {checkError && !isChecking && (
        <div className="text-sm text-danger mb-3">Couldn't run the control check — try again.</div>
      )}

      {!isChecking && !checkError && <ControlCheckFindingsList findings={findings} />}

      {hasCritical && (
        <div className="mt-4">
          <TextArea
            isLoaded
            name="override-reason"
            title="Override reason (required to activate despite the critical finding(s) above)"
            value={overrideReason}
            onChange={(e) => setOverrideReason(e.target.value)}
            placeholder="Explain why this role should still go active despite the critical finding(s)."
            rows={3}
          />
        </div>
      )}

      <div className="flex items-center gap-2.5 mt-5 pt-4 border-t border-border">
        <button type="button" className={secondaryButtonCls} onClick={onSaveDraft} disabled={isSaving}>
          {isSaving ? "Saving…" : "Save as draft"}
        </button>
        <button
          type="button"
          className={primaryButtonCls}
          onClick={onActivate}
          disabled={isSaving || isChecking || !canActivate}
          title={!canActivate ? "Provide an override reason to activate despite the critical finding(s)" : undefined}
        >
          {isSaving ? "Activating…" : "Activate"}
        </button>
      </div>
    </WizardCard>
  );
}
